<template>
  <div id="app">
    <NavTop />
    <!-- <NavTopOne ref="fixHeard" class="fix_heard" /> -->
    <router-view v-if="isRouterAlive"></router-view>
    <Footer />
    <el-backtop>
      <div class="scoll_top">
        <i class="iconfont icon-huojian"></i>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import NavTop from "./views/comcomponents/NavTop";
// import NavTopOne from "./views/comcomponents/NavTop";
import Footer from "./views/comcomponents/Footer";

export default {
  name: "app",
  // 组件刷新
  components: {
    NavTop,
    Footer,
    // NavTopOne,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      screenWidth: document.body.clientWidth,
    };
  },
  mounted() {
    console.log(this.isRouterAlive);
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        this.screenWidth = window.screenWidth;
      })();
    };
    // window.addEventListener("scroll", this.handleScroll); //监听滚动事件
  },
  watch: {
    /* 监听*/
    screenWidth(val) {
      this.screenWidth = val;
      localStorage.setItem("screenWidth", val);
    },
  },
  methods: {
    // 用于组件刷新
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 滚动条
    // handleScroll() {
    //   const top =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop; //兼容不同的浏览器
    //   if (top > 100) {
    //     this.$nextTick(() => {
    //       let Width = document.body.clientWidth;
    //       if (Width > 800) {
    //         this.$refs.fixHeard.$el.style.top = "118px";
    //       } else {
    //         this.$refs.fixHeard.$el.style.top = "4.375rem";
    //       }
    //     });
    //   } else {
    //     this.$nextTick(() => {
    //       this.$refs.fixHeard.$el.style.top = "0";
    //     });
    //   }
    // },
  },
};
</script>

<style lang="scss" type="text/scss">
@media only screen and (min-width: 800px) {
  #app {
    min-width: 1400px;
  }
}
.qrcode .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);

  .el-dialog__body {
    padding: 30px 25px;
    text-align: center !important;
    height: 800px;
    flex: 1;
    overflow: auto;
  }
}

// 导入 全局样式 和 菜单栏样式
@import "./styles/scss/sidebar.scss", "./styles/scss/common.scss",
  "./styles/scss/reset.scss", "./styles/scss/mixin.scss",
  "./styles/scss/transition.scss";

@import "../static/library/flipCard/style.scss";
html,
body,
#app {
  height: 100%;
  width: 100%;
  // min-width: 1200px !important;
  // min-height: 600px !important;
  font-family: "Barlow", sans-serif;
  color: #7b7981;
}

#app {
  //   font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-family: "Microsoft YaHei", "SimHei", "Arial", "SimSun ";

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.html_template {
  img {
    display: block;
    max-width: 100% !important;
    margin: 0 auto;
  }
}
.el-button--warning {
  color: #fff;
  background-color: #f5a623;
  border-color: #f5a623;
}
// .fix_heard {
//   min-width: 1400px;
//   position: fixed;
//   z-index: 991;
//   top: 0;
//   left: 0;
//   background-color: #fff;
//   width: 100%;
//   //   visibility: hidden;
//   transform: translateY(-120%);
//   //   transition: transform 500ms ease, visibility 500ms ease;
//   transition: all 500ms ease;
//   box-shadow: 0px 10px 60px 0px #0000000d;
// }
.el-backtop {
  background: #1989fb;
  color: #ffffff;
  font-size: 18px;
  transition: all 0.4s ease;
  font-weight: 900;
  line-height: 45px;
}
.el-backtop:hover {
  background: #1b1825;
  color: #ffffff;
  font-size: 18px;
}

// 小于800px
@media only screen and (max-width: 800px) {
  .fix_heard {
    // display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue